export enum LoanDecisionType_Enum {
  Approved = 0,
  Declined,
  Pending
}
